import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ContactFormComponent } from '../../contact-form/contact-form.component';

@Component({
  selector: 'app-ng-business-contact-section',
  standalone: true,
  imports: [CommonModule, ContactFormComponent],
  templateUrl: './contact-section.component.html',
  styleUrls: ['./contact-section.component.scss'],
})
export class ContactSectionComponent {}
